<div class="row">
  <div
    class="
      col-12 col-sm-8 col-md-6
      order-2 order-sm-1
      chat-info-section
      custom-col-padding
    "
    >
    <div class="row chat-row">
      <div class="col-12 custom-col-padding">
        <h1 [ngClass]="{ 'cahoot-heading': isCahoot }">Hi, how can we help?</h1>
      </div>
    </div>
    <div class="row chat-row">
      <div class="col-12 custom-col-padding">
        @if (!isCahoot) {
          <p class="chat-description">
            The easiest way to get the answers you need is to ask our digital
            assistant, available 24/7.
          </p>
        }
        @if (isCahoot) {
          <p class="chat-description">
            You can get in touch by sending us a secure message or by phoning our
            freephone number.
          </p>
        }
      </div>
    </div>
    @if (!isCahoot) {
      <div class="row chat-row">
        <div
          class="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5 custom-col-padding"
          >
          <common-button-control
            [buttonId]="'chatButton'"
            [label]="'Chat with us'"
            [buttonType]="'button'"
            [styleClassName]="'contactus-button'"
            (onBtnClick)="triggerEngagement()"
            >
          </common-button-control>
        </div>
      </div>
    }
  </div>
  <div
    class="
      col-12 col-sm-4 col-md-5
      offset-md-1
      order-1 order-sm-2
      chat-image-col
      custom-col-padding
    "
    >
    <img src="assets/img/lost-your-carry.svg" alt="Chat Image" class="chat-image" />
  </div>
</div>
